module.exports = __webpack_public_path__ + "static/media/Checkmark.97ec28cf.gif";